<template>
    <div id="specialRulePopup">
        <div class="specialRule-popup-bg"></div>
        <div class="content-block">
            <div id="specialRule-popup-content">
                <img :src="specialRuleImage">
            </div>
            <div class="closeBtn" @click="closePopup">我知道了</div>
        </div>
        
    </div>
</template>

<script>
export default {
    name: 'SpecialBookingRuleImagePopup',
    props: {
        specialRuleImage: {
            type: String
        },
        onGoBack: {
            type: Function
        },
        isShow: {
            type: Boolean,
            default () {
                return false
            }
        },
        closeSpecialBookingPopup: {
            type: Function
        },
        specialName:{
            type: String
        }
    },
    methods: {
        closePopup () {
            this.closeSpecialBookingPopup()
        },
        showStyle () {
            return { }
        }
    }
}
</script>

<style lang="less" scoped>
#specialRulePopup {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 9999999;
    display: grid;
    align-items: center;
    justify-content: center;
    background-color: rgba(0,0,0,0.6);
    .content-block {
        width: 325px;
        background-color: transparent;
        border-radius: 8px;
        overflow: hidden;
        position: relative;
        height: 70%;
        margin: 0;
        padding: 0;
        #specialRule-popup-content {
            height: calc(100% - 44px);
            overflow: scroll;
            line-height: 0px;
            img {
                width: 100%;
                display: block;
            }
        }
    }
    .closeBtn {
        display: grid;
        align-items: center;
        justify-content: center;
        height: 44px;
        font-size: 14px;
        line-height: 29px;
        color: #000;
        font-weight: 600;
        background: linear-gradient(to right, #FEBC10, #FAD961);
    }
}


</style>
